import PrimeIcon from './PrimeIcon'

export default function LoadingSpinner() {
    return (
        <div className="loading-spinner">
            <PrimeIcon name="sync" spin size={100} />
        </div>
    )
}
